import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const Over40IconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#3460E2', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M2.18895 7.53578L5.49455 1.86235C5.88031 1.20026 6.83685 1.20026 7.22262 1.86235L10.5282 7.53578C10.9166 8.20244 10.4357 9.03921 9.66418 9.03921H3.05299C2.28143 9.03921 1.80053 8.20244 2.18895 7.53578Z"
        fill={strokeColor}
      />
      <path
        d="M2.42773 10.4146H10.2896"
        stroke={strokeColor}
        strokeLinecap="round"
      />
    </g>
  );
};

export const Over40IconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <Over40IconGroup {...props} />
    </svg>
  );
};
